import { Link, useParams } from "react-router-dom";
import { InboxDraftsList, InboxSentList } from "./components";
import { Button, Tabs, TabsList, TabsTrigger } from "@tellescope/ui";
import { useShallowNavbarStore } from "../../store";
import { PanelLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { InboxScheduledList } from "./components/thread-list-panel/InboxScheduledList";
import { PAGE_HEADER_SIZE_STRING } from "../../constants/header-sizing";

export const InboxThreadOnlyPage = () => {
  const { t } = useTranslation("inbox");
  const params = useParams();
  const view = params.view;
  const { toggleCollapsed } = useShallowNavbarStore("toggleCollapsed");

  return (
    <div className="bg-background w-full overflow-hidden max-h-screen flex flex-col">
      <div className={`flex items-center pl-2 pr-4 border-b h-[${PAGE_HEADER_SIZE_STRING}] flex-shrink-0`}>
        <Button variant="ghost" size="icon" className="w-9 h-9 rounded-md" onClick={toggleCollapsed}>
          <PanelLeft className="h-5 w-5" />
        </Button>

        <Tabs value={view} className="ml-4">
          <TabsList className="grid grid-cols-3">
            <TabsTrigger value="drafts" data-trackingid="drafts-sent-tab-drafts" asChild>
              <Link to="../drafts">{t("Drafts")}</Link>
            </TabsTrigger>
            <TabsTrigger value="scheduled" data-trackingid="drafts-sent-tab-scheduled" asChild>
              <Link to="../scheduled">{t("Scheduled")}</Link>
            </TabsTrigger>
            <TabsTrigger value="sent" data-trackingid="drafts-sent-tab-sent" asChild>
              <Link to="../sent">{t("Sent")}</Link>
            </TabsTrigger>
          </TabsList>
        </Tabs>
      </div>
      <div className="flex justify-center">
        <div className="max-w-[750px] flex-1">
          {view === "drafts" ? (
            <InboxDraftsList />
          ) : view === "sent" ? (
            <InboxSentList />
          ) : view === "scheduled" ? (
            <InboxScheduledList />
          ) : null}
        </div>
      </div>
    </div>
  );
};
